import { IcSharedIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView } from '@gem/ui-kit';

import styles from './styles.m.css';

const SharedScreen = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <IconView
        Icon={IcSharedIcon}
        className={styles.icon}
        size="auto"
      />
      {t('sharing_screen')}
    </div>
  );
};

export default SharedScreen;
